import { useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { deleteDimensions } from '../service/dimensionService'
import { Dimension } from '../types/Dimension'
import dimensionQueryKeys from './dimensionQueryKeys'
import useUpdateQueryItem from '../../../services/api/hooks/useUpdateQueryItem'
import { getDimensionOptions } from './getDimensionOptions'

export const useDeleteDimensions = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const options = getDimensionOptions(companyId)
  const { notification } = App.useApp()
  const updateQueryItem = useUpdateQueryItem()

  if (!companyId) {
    throw new Error('Company ID is required for dimensions.')
  }

  return useMutation({
    mutationKey: dimensionQueryKeys.list({ companyId }),
    mutationFn: (dimensionIds: Dimension['dimensionId'][]) => deleteDimensions(dimensionIds, companyId),
    onSuccess() {
      updateQueryItem([options])
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
